export default __webpack_public_path__ + "static/media/maldives.8c3dd3ec.svg";